import React from 'react'

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props)
		this.state = { hasError: false, error: null, errorInfo: null }
	}

	// Atualiza o estado ao capturar o erro
	static getDerivedStateFromError(error) {
		return { hasError: true }
	}

	// Opcional: Registra o erro
	componentDidCatch(error, errorInfo) {
		// Registra o erro no console
		console.error('Error captured in ErrorBoundary:', error)
		console.error('Error details:', errorInfo)

		// Atualiza o estado com informações do erro
		this.setState({ error, errorInfo })
	}

	render() {
		if (this.state.hasError) {
			// Exibir uma interface amigável para o usuário
			return (
				<div>
					<h1>Oops! Algo deu errado.</h1>
					<p>Por favor, recarregue a página.</p>

					{/* Botão para recarregar a página */}
					<button
						onClick={() => window.location.reload()}
						style={{
							marginTop: '20px',
							padding: '10px 20px',
							cursor: 'pointer',
						}}>
						Recarregar Página
					</button>

					{/* Exibir detalhes adicionais no ambiente de desenvolvimento */}
					{process.env.NODE_ENV === 'development' && (
						<details style={{ whiteSpace: 'pre-wrap' }}>
							<summary>Clique para ver os detalhes do erro</summary>
							<p>{this.state.error && this.state.error.toString()}</p>
							<p>
								{this.state.errorInfo &&
									this.state.errorInfo.componentStack}
							</p>
						</details>
					)}
				</div>
			)
		}

		return this.props.children
	}
}

export default ErrorBoundary
